import BizOpenInApp from './biz-open-in-app.vue';

export default BizOpenInApp;
